import React from 'react';
import Rating from 'components/Rating';
import { Button } from 'components/Button';

import iconBagDollar from 'assets/icons/general/bag-dollar.svg';
import iconChat from 'assets/icons/general/chat.svg';
import iconCalendarFull from 'assets/icons/general/calendar-full.svg';
import { colors, device } from '../../styles/stylesheets';
import { typeResponsibility, typeStatus } from '../../config/tasks';

import {
  Container,
  BudgeContainer,
  BadgeCustom,
  ContactInfo,
  ContactPhoto,
  ContactName,
  ContactRating,
  QuoteInfo,
  QuoteIcon,
  QuoteTitle,
  QuoteValue,
  ChatAction,
  IconChat,
  QuoteActionQuote,
  QuoteActionTask,
  ActionTaskIcon,
} from './styles';

function Quote({ quote, status, responsibility }) {
  const redirectChat = (quote_id) => {
    window.location.href = `${process.env.SITE_PATH}u/orcamentos/${quote_id}/chat`;
  };

  const textChat = quote.chat ? 'Responder' : 'Conversar'; // corrigir

  const chatActionDisplay = status.b2b_status_id === typeStatus.AWATING;
  const actionQuoteDisplay = status.b2b_status_id === typeStatus.AWATING
    && responsibility === typeResponsibility.TENANT;
  const actionTaskDisplay = status.b2b_status_id === typeStatus.HIRED
    || (false && status.b2b_status_id === typeStatus.DONE);

  const bugdetDisplay = quote && quote.selected;

  const actionQuoteText = 'Contratar';
  const actionTaskText = status.b2b_status_id === typeStatus.HIRED
    ? (
      <Button onClick={() => redirectChat(quote.quote_id)} size="10px">
        <ActionTaskIcon src={iconCalendarFull} alt="ícone de calendário" />
        Agendar serviço
      </Button>
    ) : (
      <Button onClick={() => redirectChat(quote.quote_id)} size="10px">
        Avaliar serviço
      </Button>
    );

  const getQuoteValue = quoteParam => (
    quoteParam.price ? `R$ ${quoteParam.price}` : 'Visível apenas para o proprietário'
  );

  const w = window;
  const e = document.documentElement;
  const g = document.getElementsByTagName('body')[0];

  const widthBrowser = w.innerWidth || e.clientWidth || g.clientWidth;

  return (
    <Container actionQuote={actionQuoteDisplay ? 1 : 0}>
      <ContactInfo>
        <ContactPhoto
          src={quote.profile_picture
            || `https://ui-avatars.com/api/?background=FF7700&color=fff&name=${quote.name && quote.name.replace(' ', '%20')}`}
        />
        <ContactName>{quote.name}</ContactName>
        <ContactRating>
          <Rating starSize="12" initialRating={quote.rating} readonly />
          {
            quote.total && (
              <span>{` (${quote.total})`}</span>
            )}
        </ContactRating>
      </ContactInfo>
      <QuoteInfo>
        <QuoteIcon src={iconBagDollar} alt="ícone de bolsa de dinheiro" />
        <QuoteTitle>Orçamento</QuoteTitle>
        <QuoteValue>{getQuoteValue(quote)}</QuoteValue>
      </QuoteInfo>
      {
        chatActionDisplay && (
          <ChatAction onClick={() => redirectChat(quote.quote_id)}>
            <IconChat src={iconChat} alt="ícone de bolões de chat" />
            {textChat}
          </ChatAction>
        )
      }
      {
        !chatActionDisplay && bugdetDisplay && (
          <BudgeContainer>
            <BadgeCustom color={colors.info}>
              {
                widthBrowser > (device.screen.mobileL + device.screen.tablet) / 2
                  ? 'Profissional contratado'
                  : 'Contratado'
              }
            </BadgeCustom>
          </BudgeContainer>
        )
      }
      {
        actionQuoteDisplay && (
          <QuoteActionQuote>
            <Button onClick={() => redirectChat(quote.quote_id)} size="10px">{actionQuoteText}</Button>
          </QuoteActionQuote>
        )
      }
      {
        actionTaskDisplay && (
          <QuoteActionTask>
            {actionTaskText}
          </QuoteActionTask>
        )
      }
    </Container>
  );
}

export default Quote;
